import React from 'react';
import { Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import WarningModal from '../../../../../components/WarningModal/WarningModal';
import { getIsLoading, getIsResubscribeModalVisible } from '../../../store/claim/claim.selectors';
import { claimRequest, setShowResubscribeModal } from '../../../store/claim/claim.actions';
import useTrackRecipient from '../../../../../hooks/useTrackRecipient';
import { getProduct } from '../../../store/giftFlow/giftFlow.selectors';
import { getGiftHashId } from '../../../store/data/data.selectors';
import { getBranding } from '../../../../../store/branding/branding.selectors';
import { BrandingFields } from '../../../../../types/Branding.types';

const ResubscribeModal = (): JSX.Element => {
  const dispatch = useDispatch();
  const trackEvent = useTrackRecipient();

  const isLoading = useSelector(getIsLoading);
  const customBranding = useSelector(getBranding);
  const isResubscribeModalVisible = useSelector(getIsResubscribeModalVisible);
  const product = useSelector(getProduct);
  const hashId = useSelector(getGiftHashId);

  const handleSubmit = () => {
    dispatch(claimRequest(hashId));
    trackEvent('Warning popup - Clicked resubscribe recipient email', { product });
  };

  const handleDiscard = () => dispatch(setShowResubscribeModal(false));

  return (
    <WarningModal
      title={`Please Confirm Re-subscription to ${customBranding[BrandingFields.companyName]}`}
      isOpen={isResubscribeModalVisible}
      isLoading={isLoading}
      onSubmit={handleSubmit}
      onDiscard={handleDiscard}
    >
      <Typography className="Body-Regular-Left-Static">
        Accepting this invitation will resubscribe you to {customBranding[BrandingFields.companyName]} Gifts and Gift
        Invitations. Please confirm before accepting your gift.
      </Typography>
    </WarningModal>
  );
};

export default ResubscribeModal;
